import { mapStateToControlProps, rankWith } from '@jsonforms/core';
import { html } from '@microsoft/fast-element';
import { isInvisible } from '../testers/isInvisible';
import { INVISIBLE_CONTROL_RANK } from './RenderersRanks';
export const InvisibleControlRendererTemplate = html `
  <template>
    <pre
      :value=${(x) => x.control.data || ''}
      id=${(x) => x.control.path}
      data-test-id=${(x) => x.control.path}
      style="display: none"
    ></pre>
  </template>
`;
export const InvisibleControlEntry = {
    renderer: InvisibleControlRendererTemplate,
    tester: rankWith(INVISIBLE_CONTROL_RANK, isInvisible),
    mapper: mapStateToControlProps,
};
